


























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { MCQueryList, BindMedicineCabinet, QueryMedicineCabinetList, UnbindMedicineCabinet } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { Message, MessageBox } from 'element-ui'
import { MedicineCabinetStatusFormat } from '@/utils/tyepconvert'

@Component({
  components: { VTable },
})
export default class MCBindMedicneCabinetDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.formData = {}
    this.show = false
  }
  private mcOption = []
  private data: any = {}
  private formData: any = {}
  private show = false
  private loading = false

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    medicineCabinetId: [this.requiredRule],
  }

  private tableData = []

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '药柜名称', param: 'name' },
    { title: '设备编号', param: 'deviceId' },
    { title: '药柜状态', param: 'status' , formatter: MedicineCabinetStatusFormat},
    { title: '未知', param: 'address' },
    {
      title: '操作',
      operation: [{ title: '解绑', icon: 'el-icon-delete', class: 'red', click: this.unbind }],
    },
  ]

  public async open(data: any) {
    this.show = true
    this.data = data
    this.loadMc()
  }

  private async loadMc() {
    const result = await QueryMedicineCabinetList({ investorUserNo: this.data.userNo })
    this.tableData = result.list
  }

  private async unbind(data: any) {
    // 解绑
    MessageBox.confirm('确定要解绑吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UnbindMedicineCabinet({
        medicineCabinetId: data.id,
        investorUserNo: this.data.userNo,
      })
      if (ruslt) {
        Message.success('解绑成功')
        this.loadMc()
      }
    })
  }

  private async remoteMethod(query: string) {
    this.loading = true
    // 防止接口失败
    setTimeout(() => {
      if (this.loading) {
        this.loading = false
      }
    }, 1000)
    const result = await MCQueryList({  name: query, startRow: 0, limit: 10 })

    const list = result.list
    const m = list.map((e: any) => {
      return { label: e.name + '(' + e.deviceId + ')', value: e.id }
    })

    this.mcOption = m

    this.loading = false
  }

  public async save() {
    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        const result = await BindMedicineCabinet({
          medicineCabinetId: this.formData.medicineCabinetId,
          investorUserNo: this.data.userNo,
        })

        this.loadMc()
      } else {
        return false
      }
    })
  }
}
